angular.module('unica_campaign_template.campaign_template_services')

.factory('CampaignTemplateDeleteService', function ($http, getBaseApiURL) {

	var campaignTemplateDeleteService = {};

	campaignTemplateDeleteService.delete = function (campaignTemplateId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/campaign-template/delete/' + campaignTemplateId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return campaignTemplateDeleteService;
});